import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed024978"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col md:flex-row gap-6 w-full px-8 md:px-16 py-12 relative" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Edit", -1))
const _hoisted_3 = { class: "flex flex-col w-full md:w-2/3 justify-center text-center md:text-left space-y-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl md:text-5xl font-bold leading-tight" }, "Beginner to Pro : Learn the Stock Market ", -1))
const _hoisted_5 = { class: "text-lg md:text-xl" }
const _hoisted_6 = { class: "inline-block" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-3xl" }, "Pro", -1))
const _hoisted_8 = { class: "flex flex-row w-full md:w-2/3 justify-right items-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { key: 1 }

import { PencilIcon } from "@heroicons/vue/24/outline";
import { ref } from "vue";
import EditHomePageDialog from "@/components/admin/EditHomePageDialog.vue";
import { useUserStore } from "@/stores/userStore";
import { storeToRefs } from "pinia";
import { useHomeStore } from "@/stores/homeStore";
import { SunIcon, MoonIcon, FireIcon } from '@heroicons/vue/24/solid'



export default /*#__PURE__*/_defineComponent({
  __name: 'HomeSection',
  setup(__props) {

const userStore = useUserStore();
const { isAdmin } = storeToRefs(userStore);

const homeStore = useHomeStore();
const { homePageData } = storeToRefs(homeStore);

const isEditHomePageDialogOpen = ref(false);
const openEditHomePageDialog = () => {
  isEditHomePageDialogOpen.value = true;
};

const closeEditHomePageDialog = () => {
  isEditHomePageDialogOpen.value = false;
  homeStore.getHomePageData(true);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_unref(isAdmin))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: openEditHomePageDialog,
          class: "flex flex-row items-center text-white justify-center bg-brand-secondary px-6 py-2 rounded-xl absolute top-6 right-6 shadow-lg hover:bg-brand-secondary-dark transition"
        }, [
          _createVNode(_unref(PencilIcon), { class: "h-5 w-5" }),
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(homePageData)?.description), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/pro",
          class: "font-bold text-5xl bg-gradient-to-r from-pink-500 to-yellow-500 text-white text-[16px] inline-flex items-center justify-center py-1.5 px-5 rounded-full transition-colors duration-300 hover:from-pink-600 hover:to-yellow-600"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(FireIcon), { class: "h-8 w-8 mr-2" }),
            _hoisted_7
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("img", {
        src: _unref(homePageData)?.image,
        alt: "Graph logo",
        class: "w-full object-contain h-[320px] md:h-[520px]"
      }, null, 8, _hoisted_9)
    ]),
    (isEditHomePageDialogOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(EditHomePageDialog, {
            "on-close": closeEditHomePageDialog,
            homeData: _unref(homePageData)
          }, null, 8, ["homeData"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})